import { useApp } from "@/context/AppContext";
import { Quote } from "lucide-react";

const Testimonials = ({ eyebrow, title }) => {
  const { t } = useApp();
  const items = t.testimonials;
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32 bg-[#0A0A0A] text-white overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]">
        <div className="absolute inset-0" style={{
          backgroundImage:
            "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }} />
      </div>
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex items-center gap-3 text-xs tracking-[0.2em] uppercase font-bold text-[#3A00FF]">
          <span className="inline-block h-[1px] w-8 bg-[#3A00FF]" />
          {eyebrow}
        </div>
        <h2 className="mt-4 max-w-3xl text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black leading-tight font-[Cabinet_Grotesk]">
          {title}
        </h2>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8">
          {items.map((it, idx) => (
            <figure
              key={idx}
              data-testid={`testimonial-card-${idx}`}
              className="lg:col-span-8 border border-white/20 p-8 lg:p-12 bg-white/[0.02] backdrop-blur-sm"
            >
              <Quote className="h-8 w-8 text-[#3A00FF]" aria-hidden />
              <blockquote className="mt-6 text-xl lg:text-2xl leading-relaxed tracking-tight text-white/90 font-[Cabinet_Grotesk]">
                “{it.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <div className="h-10 w-10 border border-white/40 grid place-items-center text-xs tracking-widest">
                  {it.author?.[0] || "Z"}
                </div>
                <div>
                  <div className="text-sm font-bold">{it.author}</div>
                  <div className="text-xs uppercase tracking-[0.2em] text-white/60">
                    {it.role}
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}

          <aside className="lg:col-span-4 border border-white/20 p-8 lg:p-12 flex flex-col justify-between">
            <div className="text-xs uppercase tracking-[0.2em] text-white/60">
              Trust signals
            </div>
            <div className="mt-8 space-y-6">
              <div>
                <div className="text-4xl font-black font-[Cabinet_Grotesk]">100%</div>
                <div className="text-sm text-white/70 mt-1">
                  On-time launches for local business clients.
                </div>
              </div>
              <div>
                <div className="text-4xl font-black font-[Cabinet_Grotesk]">4.9/5</div>
                <div className="text-sm text-white/70 mt-1">
                  Average client satisfaction across projects.
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
